import { render, staticRenderFns } from "./CustomerDirectoryComponent.vue?vue&type=template&id=2e1e5f28&scoped=true"
import script from "./CustomerDirectoryComponent.vue?vue&type=script&lang=js"
export * from "./CustomerDirectoryComponent.vue?vue&type=script&lang=js"
import "./CustomerDirectoryComponent.vue?vue&type=style&index=0&id=2e1e5f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e5f28",
  null
  
)

export default component.exports